import { useEffect, useState } from "react";
import { fetchDebtsToPayAsPropertyCuentaPendingPeriod } from "../api/finance";
import { fetchAllPages } from "../api/pagination";
import handleErrorMessage from "../errors/handleErrorMessage";

const usePendingDebtPeriods = (condominiumId, propertyId) => {
  const [periods, setPeriods] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    let isMounted = true;
    setPeriods([]);
    setHasError(false);
    setIsLoading(Boolean(condominiumId));

    if (!condominiumId) return;

    const loadPeriods = async () => {
      try {
        const response = await fetchAllPages((page, pageSize) =>
          fetchDebtsToPayAsPropertyCuentaPendingPeriod(page, pageSize, {
            condominiumId,
            property_id: propertyId,
          })
        );
        if (isMounted) {
          setPeriods(
            (response?.data || []).filter(
              (period) => Number(period.total_amount) > 0
            )
          );
        }
      } catch (error) {
        if (isMounted) {
          setHasError(true);
          handleErrorMessage(error);
        }
      } finally {
        if (isMounted) setIsLoading(false);
      }
    };

    loadPeriods();
    return () => {
      isMounted = false;
    };
  }, [condominiumId, propertyId]);

  return { periods, isLoading, hasError };
};

export default usePendingDebtPeriods;
